import { Toaster } from 'sonner';
import '@/styles/notification-toaster.css';

/**
 * @experimental
 * Not adapted for dark mode
 * @constructor
 */
const NotificationToaster = () => {
  return (
    <Toaster
      position="bottom-right"
      duration={8000}
      // closeButton
      richColors
      expand={false}
      visibleToasts={3}
      style={{
        fontFamily: 'inherit',
      }}
      toastOptions={{
        style: {
          background: '#222',
          color: 'white',
          border: '1px solid #333',
        },
        className: 'notification-toast-wrapper',
      }}
    />
  );
};

export default NotificationToaster;
